import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import moment from 'moment-timezone';
import Loading from '../../common/components/Loading';
import Icon from '../../common/icons/Icon';

class RequestedSessionModal extends Component {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    session: PropTypes.object.isRequired,
    toggleModal: PropTypes.func.isRequired,
  };

  state = {
    canceling: false,
  };

  onToggleCancel = () => {
    this.setState(state => ({ canceling: !state.canceling }));
  };

  render() {
    const { loading, onCancel, session, toggleModal } = this.props;
    const { canceling } = this.state;

    if (loading) {
      return <Loading />;
    }

    if (canceling) {
      return (
        <div>
          <div className="booking-modal">
            <button className="close-button" onClick={toggleModal}>
              <Icon icon="Close" />
            </button>
            <h3>Cancel Follow-Up Request</h3>
            <div>If cancelled, it may take up to 10 days for the authorized charge to be released from the card.</div>
          </div>
          <div className="modal__actions">
            <button type="button" className="button button--theme--plain" onClick={this.onToggleCancel}>
              Go Back
            </button>
            <button type="button" className="button" onClick={onCancel}>
              Confirm
            </button>
          </div>
        </div>
      );
    }

    return (
      <div className="session-requested">
        <div className="booking-modal">
          <button className="close-button" onClick={toggleModal}>
            <Icon icon="Close" />
          </button>
          {session.movementSpecialist ? (
            <div className="ms--header">
              <h3>Follow-Up Request</h3>
              <div
                style={{
                  backgroundImage: `url(${get(
                    session,
                    'movementSpecialist.movementSpecialistProfile.profileImage.location'
                  )})`,
                }}
                className="ms__request-img"
              />
            </div>
          ) : (
            <div className="booking-modal--header">
              <Icon class="tathata-logo" icon="Tathata-Logo" />
              <h3>Follow-Up Request</h3>
            </div>
          )}
          <h4>{get(session, 'movementSpecialist.movementSpecialistProfile.name')}</h4>
          {session.note && (
            <div className="booking-note">
              <i>"{session.note}"</i>
            </div>
          )}
          <div className="booking-times__wrapper">
            <p>Times Requested</p>
            <ul>
              {session.requested_dates.map((value, index) => {
                const date = moment(value).tz(session.time_zone_id);
                return (
                  <li key={`date-${index}`}>
                    <div>
                      <strong>Date:</strong>&nbsp;{date.format('L')}
                    </div>
                    <div>
                      <strong>Time:</strong>&nbsp;{date.format('h:mmA z')}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        <div className="modal__actions">
          <button type="button" onClick={this.onToggleCancel} className="button button--theme--secondary">
            Cancel Follow-Up
          </button>
        </div>
      </div>
    );
  }
}

export default RequestedSessionModal;



// WEBPACK FOOTER //
// ./src/subscription/sessions/RequestedSessionModal.js